var Ee = Object.defineProperty;
var Se = (n, t, e) => t in n ? Ee(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var At = (n, t, e) => (Se(n, typeof t != "symbol" ? t + "" : t, e), e), wt = (n, t, e) => {
  if (!t.has(n))
    throw TypeError("Cannot " + e);
};
var l = (n, t, e) => (wt(n, t, "read from private field"), e ? e.call(n) : t.get(n)), r = (n, t, e) => {
  if (t.has(n))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(n) : t.set(n, e);
}, xt = (n, t, e, o) => (wt(n, t, "write to private field"), o ? o.call(n, e) : t.set(n, e), e);
var i = (n, t, e) => (wt(n, t, "access private method"), e);
const $e = {
  title: "Cookies compliance",
  message: "We use cookies",
  policy: "",
  btnAccept: "Accept all",
  btnReject: "Reject all",
  btnDismiss: "Cookies policy",
  btnInfo: "Details",
  btnSettings: "Settings",
  content_align: "left",
  info: ""
};
let Te = (n) => crypto.getRandomValues(new Uint8Array(n)), Ae = (n, t, e) => {
  let o = (2 << Math.log(n.length - 1) / Math.LN2) - 1, s = -~(1.6 * o * t / n.length);
  return (c = t) => {
    let a = "";
    for (; ; ) {
      let d = e(s), u = s;
      for (; u--; )
        if (a += n[d[u] & o] || "", a.length === c)
          return a;
    }
  };
}, je = (n, t = 21) => Ae(n, t, Te);
const Le = je("1234567890abcdef", 10);
var Re = typeof global == "object" && global && global.Object === Object && global, Oe = typeof self == "object" && self && self.Object === Object && self, He = Re || Oe || Function("return this")(), B = He.Symbol, Wt = Object.prototype, Be = Wt.hasOwnProperty, Ie = Wt.toString, I = B ? B.toStringTag : void 0;
function Me(n) {
  var t = Be.call(n, I), e = n[I];
  try {
    n[I] = void 0;
    var o = !0;
  } catch {
  }
  var s = Ie.call(n);
  return o && (t ? n[I] = e : delete n[I]), s;
}
var _e = Object.prototype, De = _e.toString;
function Ne(n) {
  return De.call(n);
}
var Ue = "[object Null]", Fe = "[object Undefined]", jt = B ? B.toStringTag : void 0;
function Ge(n) {
  return n == null ? n === void 0 ? Fe : Ue : jt && jt in Object(n) ? Me(n) : Ne(n);
}
function We(n) {
  return n != null && typeof n == "object";
}
var Pe = "[object Symbol]";
function ze(n) {
  return typeof n == "symbol" || We(n) && Ge(n) == Pe;
}
function Ze(n, t) {
  for (var e = -1, o = n == null ? 0 : n.length, s = Array(o); ++e < o; )
    s[e] = t(n[e], e, n);
  return s;
}
var Je = Array.isArray, qe = 1 / 0, Lt = B ? B.prototype : void 0, Rt = Lt ? Lt.toString : void 0;
function Pt(n) {
  if (typeof n == "string")
    return n;
  if (Je(n))
    return Ze(n, Pt) + "";
  if (ze(n))
    return Rt ? Rt.call(n) : "";
  var t = n + "";
  return t == "0" && 1 / n == -qe ? "-0" : t;
}
function zt(n) {
  return n == null ? "" : Pt(n);
}
function Ke(n, t, e, o) {
  var s = -1, c = n == null ? 0 : n.length;
  for (o && c && (e = n[++s]); ++s < c; )
    e = t(e, n[s], s, n);
  return e;
}
function Ve(n) {
  return function(t) {
    return n == null ? void 0 : n[t];
  };
}
var Ye = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Qe = Ve(Ye);
const Xe = Qe;
var tn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, en = "\\u0300-\\u036f", nn = "\\ufe20-\\ufe2f", on = "\\u20d0-\\u20ff", sn = en + nn + on, cn = "[" + sn + "]", an = RegExp(cn, "g");
function rn(n) {
  return n = zt(n), n && n.replace(tn, Xe).replace(an, "");
}
var dn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function un(n) {
  return n.match(dn) || [];
}
var ln = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function mn(n) {
  return ln.test(n);
}
var Zt = "\\ud800-\\udfff", fn = "\\u0300-\\u036f", gn = "\\ufe20-\\ufe2f", pn = "\\u20d0-\\u20ff", hn = fn + gn + pn, Jt = "\\u2700-\\u27bf", qt = "a-z\\xdf-\\xf6\\xf8-\\xff", bn = "\\xac\\xb1\\xd7\\xf7", kn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", wn = "\\u2000-\\u206f", xn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Kt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Cn = "\\ufe0e\\ufe0f", Vt = bn + kn + wn + xn, Yt = "['’]", Ot = "[" + Vt + "]", yn = "[" + hn + "]", Qt = "\\d+", vn = "[" + Jt + "]", Xt = "[" + qt + "]", te = "[^" + Zt + Vt + Qt + Jt + qt + Kt + "]", En = "\\ud83c[\\udffb-\\udfff]", Sn = "(?:" + yn + "|" + En + ")", $n = "[^" + Zt + "]", ee = "(?:\\ud83c[\\udde6-\\uddff]){2}", ne = "[\\ud800-\\udbff][\\udc00-\\udfff]", E = "[" + Kt + "]", Tn = "\\u200d", Ht = "(?:" + Xt + "|" + te + ")", An = "(?:" + E + "|" + te + ")", Bt = "(?:" + Yt + "(?:d|ll|m|re|s|t|ve))?", It = "(?:" + Yt + "(?:D|LL|M|RE|S|T|VE))?", oe = Sn + "?", se = "[" + Cn + "]?", jn = "(?:" + Tn + "(?:" + [$n, ee, ne].join("|") + ")" + se + oe + ")*", Ln = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Rn = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", On = se + oe + jn, Hn = "(?:" + [vn, ee, ne].join("|") + ")" + On, Bn = RegExp([
  E + "?" + Xt + "+" + Bt + "(?=" + [Ot, E, "$"].join("|") + ")",
  An + "+" + It + "(?=" + [Ot, E + Ht, "$"].join("|") + ")",
  E + "?" + Ht + "+" + Bt,
  E + "+" + It,
  Rn,
  Ln,
  Qt,
  Hn
].join("|"), "g");
function In(n) {
  return n.match(Bn) || [];
}
function Mn(n, t, e) {
  return n = zt(n), t = e ? void 0 : t, t === void 0 ? mn(n) ? In(n) : un(n) : n.match(t) || [];
}
var _n = "['’]", Dn = RegExp(_n, "g");
function Nn(n) {
  return function(t) {
    return Ke(Mn(rn(t).replace(Dn, "")), n, "");
  };
}
var Mt = Nn(function(n, t, e) {
  return n + (e ? "-" : "") + t.toLowerCase();
});
function Un(n) {
  let t = "";
  function e(o, s = "") {
    Object.entries(o).forEach(([c, a]) => {
      if (typeof a == "object")
        e(a, `${s}${c}`);
      else {
        const d = `--cc${s ? `-${Mt(s)}` : ""}-${Mt(c)}`;
        t += `${d}: ${a};
`;
      }
    });
  }
  return e(n), t;
}
var x, m, U, $, tt, ce, et, ie, nt, ae, ot, re, st, de, F, yt, T, J, A, q, ct, ue, j, K, it, le, L, V, y, D, G, vt, at, me, v, N, R, Y, rt, fe, dt, ge, ut, pe, lt, he, mt, be, ft, ke, gt, we, W, Et, pt, xe, P, St, ht, Ce, z, $t, bt, ye, kt, ve, O, Q, H, X, C, S;
class Pn {
  constructor(t) {
    r(this, tt);
    r(this, et);
    r(this, nt);
    r(this, ot);
    r(this, st);
    r(this, F);
    r(this, T);
    r(this, A);
    r(this, ct);
    r(this, j);
    r(this, it);
    r(this, L);
    r(this, y);
    r(this, G);
    r(this, at);
    r(this, v);
    r(this, R);
    r(this, rt);
    r(this, dt);
    r(this, ut);
    r(this, lt);
    r(this, mt);
    r(this, ft);
    r(this, gt);
    r(this, W);
    r(this, pt);
    r(this, P);
    r(this, ht);
    r(this, z);
    r(this, bt);
    r(this, kt);
    r(this, O);
    r(this, H);
    r(this, C);
    At(this, "params");
    r(this, x, !1);
    r(this, m, {});
    r(this, U, "consentcookies_status");
    r(this, $, []);
    this.params = t ?? {}, i(this, ct, ue).call(this), i(this, tt, ce).call(this), i(this, et, ie).call(this) && (i(this, nt, ae).call(this) ? (i(this, st, de).call(this), i(this, y, D).call(this), i(this, C, S).call(this, "load")) : (i(this, j, K).call(this), i(this, C, S).call(this, "first-load")));
  }
  // #region public methods
  getStatus() {
    return l(this, x);
  }
  getConfig() {
    return this.params;
  }
  showMessage() {
    try {
      i(this, j, K).call(this), i(this, G, vt).call(this);
    } catch {
      console.error("ERROR: Can not show message");
    }
  }
  removeCookies() {
    document.cookie.split(";").forEach((e) => {
      const [o] = e.trim().split("=");
      document.cookie = `${o}=""; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${this.params.path}`;
    });
  }
  toggleSettings() {
    i(this, R, Y).call(this);
  }
  // #endregion public methods
}
x = new WeakMap(), m = new WeakMap(), U = new WeakMap(), $ = new WeakMap(), tt = new WeakSet(), ce = function() {
  if (this.params.theme) {
    const t = Un(this.params.theme), e = document.createElement("style");
    e.innerHTML = `:root { ${t} }`, document.head.appendChild(e);
  }
}, et = new WeakSet(), ie = function() {
  var e;
  const t = window.location.pathname;
  return !((e = this.params.ignorePages) != null && e.some((o) => t !== "" && t.includes(o)));
}, nt = new WeakSet(), ae = function() {
  return xt(this, x, (document.cookie.split(";").some((t) => t.trim().startsWith(l(this, U))) || "") !== ""), l(this, x);
}, ot = new WeakSet(), re = function(t) {
  return !!l(this, m)[t];
}, st = new WeakSet(), de = function() {
  document.cookie.split(" ").forEach((t) => {
    const [e] = t.split("=");
    i(this, ot, re).call(this, e) && (l(this, m)[e].status = !0);
  });
}, F = new WeakSet(), yt = function(t) {
  return !!(t != null && t.cookies);
}, T = new WeakSet(), J = function(t) {
  var e;
  return (e = this.params.cookies) == null ? void 0 : e.find((o) => o.name === t);
}, A = new WeakSet(), q = function(t) {
  if (t)
    return l(this, m)[t];
}, ct = new WeakSet(), ue = function() {
  var t, e, o, s, c, a, d, u;
  this.params = this.params || {}, this.params.cookies = this.params.cookies || [];
  for (const p in this.params.cookies) {
    const f = this.params.cookies[p];
    f && (f.manageFunction && l(this, $).push(f), i(this, F, yt).call(this, f) ? (t = f.cookies) == null || t.forEach((b) => {
      var Tt;
      b.manageFunction && l(this, $).push(b), l(this, m)[b.name] = {
        status: !1,
        parent: (Tt = this.params.cookies) == null ? void 0 : Tt[p],
        ...b
      };
    }) : l(this, m)[f == null ? void 0 : f.name] = {
      status: !1,
      ...f
    });
  }
  (e = this.params).mainWindowSettings ?? (e.mainWindowSettings = !1), (o = this.params).position ?? (o.position = "bottom-left"), (s = this.params).btnDismissPosition ?? (s.btnDismissPosition = "bottom-left"), (c = this.params).expirationDays ?? (c.expirationDays = 0), (a = this.params).animation ?? (a.animation = !0), (d = this.params).path ?? (d.path = "path=/"), (u = this.params).hideDescription ?? (u.hideDescription = !0), this.params.content = {
    ...$e,
    ...this.params.content
  };
}, j = new WeakSet(), K = function() {
  var t, e, o, s, c;
  if (this.params.mainWindowSettings)
    i(this, R, Y).call(this);
  else if (!document.getElementById("cc-window")) {
    const a = `cc-pos-${this.params.position}`, d = `cc-content-${(t = this.params.content) == null ? void 0 : t.align}`, u = ["bottom", "bottom-right", "bottom-left", "bottom-center"].includes(this.params.position ?? "") ? "beforeend" : "afterbegin", p = i(this, it, le).call(this), f = ((e = this.params.content) == null ? void 0 : e.policy) !== "" && ((o = this.params.content) == null ? void 0 : o.policyLink) !== "" ? `<a href="${this.params.content.policyLink}" target="_blank">${this.params.content.policy}</a>` : "", b = `
        <div id="cc-window" class="cc-window ${a} ${d} ${this.params.animation ? "cc-animation-in" : ""}">
            <div class="cc-window-content">
              <div class="cc-window-title">${(s = this.params.content) == null ? void 0 : s.title}</div>
              <div class="cc-window-message">${(c = this.params.content) == null ? void 0 : c.message} <span class="cc-window-policy">${f}</span></div>
              <div class="cc-window-buttons">${p}</div>
          </div>
        </div>
      `;
    document.body.insertAdjacentHTML(u, b), i(this, z, $t).call(this);
  }
}, it = new WeakSet(), le = function() {
  var t, e;
  if ((t = this.params) != null && t.buttons && Array.isArray(this.params.buttons)) {
    let o = "";
    return this.params.buttons.forEach(
      (s) => {
        var c, a, d, u;
        s === "accept" ? o += `<button type="button" id="cc-btn-accept" class="cc-btn-accept">${(c = this.params.content) == null ? void 0 : c.btnAccept}</button>` : s === "reject" ? o += `<button type="button" id="cc-btn-reject" class="cc-btn-reject">${(a = this.params.content) == null ? void 0 : a.btnReject}</button>` : s === "info" ? o += `<button type="button" id="cc-btn-info" class="cc-btn-info">${(d = this.params.content) == null ? void 0 : d.btnInfo}</button>` : s === "settings" && (o += `<button type="button" id="cc-btn-settings" class="cc-btn-settings">${(u = this.params.content) == null ? void 0 : u.btnSettings}</button>`);
      }
    ), o;
  }
  return `<button type="button" id="cc-btn-accept" class="cc-btn-accept">${(e = this.params.content) == null ? void 0 : e.btnAccept}</button>`;
}, L = new WeakSet(), V = function() {
  if (!this.params.mainWindowSettings) {
    const t = document.getElementById("cc-window");
    this.params.animation && t ? (["accept", "reject", "info", "settings"].forEach((e) => {
      const o = document.getElementById(`cc-btn-${e}`);
      o && (o.id = `cc-btn-${e}-out`);
    }), t.id = "cc-window-out", t.classList.remove("cc-animation-in"), t.classList.add("cc-animation-out"), setTimeout(() => t == null ? void 0 : t.remove(), 2e3)) : t == null || t.remove();
  }
}, y = new WeakSet(), D = function() {
  var e, o, s;
  if (!document.getElementById("cc-btn-dismiss") && ((o = (e = this.params) == null ? void 0 : e.buttons) != null && o.includes("dismiss"))) {
    const c = `cc-pos-${this.params.btnDismissPosition}`, a = ["top-right", "top-left"].includes(this.params.position ?? "") ? "afterbegin" : "beforeend";
    document.body.insertAdjacentHTML(a, `
        <div id="cc-btn-dismiss" class="${c}">
          ${((s = this.params.content) == null ? void 0 : s.btnDismiss) ?? ""}
        </div>
      `), i(this, z, $t).call(this);
  }
}, G = new WeakSet(), vt = function() {
  var t;
  (t = document.getElementById("cc-btn-dismiss")) == null || t.remove();
}, at = new WeakSet(), me = function() {
  var t;
  if ((t = this.params.content) != null && t.info) {
    const e = document.createElement("div");
    e.innerHTML = this.params.content.info ?? "", i(this, P, St).call(this, "cc-window-info", e);
  }
}, v = new WeakSet(), N = function(t, e, o) {
  const s = document.createElement(t);
  return s.className = e, s.innerHTML = o ?? "", s;
}, R = new WeakSet(), Y = function() {
  var e;
  const t = i(this, v, N).call(this, "div", "cc-window-settings-cookies");
  i(this, rt, fe).call(this, t), (e = this.params.cookies) == null || e.forEach((o) => {
    const s = i(this, dt, ge).call(this, o.name);
    s && t.appendChild(s);
  }), i(this, ft, ke).call(this, t), i(this, gt, we).call(this, t), i(this, P, St).call(this, "cc-window-settings", t), i(this, bt, ye).call(this);
}, rt = new WeakSet(), fe = function(t) {
  var e;
  if ((e = this.params.content) != null && e.settingsHeader) {
    const o = i(this, v, N).call(this, "div", "cc-window-settings-header", this.params.content.settingsHeader);
    t.appendChild(o);
  }
}, dt = new WeakSet(), ge = function(t) {
  const e = Le(), o = document.createElement("div");
  o.setAttribute("id", t), o.className = "cc-window-settings-cookie";
  const s = i(this, v, N).call(this, "div", "cc-window-settings-cookie-content"), c = i(this, ut, pe).call(this, t, e), a = i(this, lt, he).call(this, t, e), d = i(this, mt, be).call(this, t);
  return c && s.appendChild(c), a && s.appendChild(a), o.insertAdjacentElement("afterbegin", s), d && o.insertAdjacentElement("beforeend", d), o;
}, ut = new WeakSet(), pe = function(t, e) {
  const o = i(this, T, J).call(this, t);
  if (o) {
    const s = i(this, v, N).call(this, "div", "cc-window-settings-cookie-title", o.title);
    return o.description && this.params.hideDescription && (s.innerHTML += ` <div id="cc-window-icon-dropdown-id-${e}">&#10095;</div>`, s.classList.add("cc-window-settings-cookie-title-dropdown"), s.addEventListener("click", () => {
      i(this, pt, xe).call(this, String(e));
    })), s;
  }
}, lt = new WeakSet(), he = function(t, e) {
  const o = i(this, T, J).call(this, t);
  if (o != null && o.description) {
    const s = document.createElement("div");
    return s.id = `cc-window-desc-id-${e}`, s.className = "cc-window-settings-cookie-desc", o != null && o.title && this.params.hideDescription && (s.style.display = "none"), s.innerHTML = o.description ?? "", s;
  }
}, mt = new WeakSet(), be = function(t) {
  var p, f, b;
  const e = i(this, T, J).call(this, t), o = i(this, F, yt).call(this, e);
  if (!e)
    return;
  const s = (o ? (f = i(this, A, q).call(this, (p = e.cookies) == null ? void 0 : p[0].name)) == null ? void 0 : f.status : (b = i(this, A, q).call(this, t)) == null ? void 0 : b.status) ?? !1;
  let c = "";
  l(this, x) ? c = s ? " checked" : "" : c = e.checked ? " checked" : "";
  const a = e.disabled && c !== "" ? "disabled" : "", d = e.name ?? "", u = document.createElement("div");
  return u.className = "cc-window-settings-cookie-value", u.innerHTML = `<label class="switch" for="cc-cookie-${d}"><input type="checkbox" class="cc-cookie-checkbox" id="cc-cookie-${d}" data-name="${d}" name="cc-cookie-${d}" ${c} ${a}><span class="slider round"></span></label>`, u;
}, ft = new WeakSet(), ke = function(t) {
  var s, c;
  const e = ((s = this.params.content) == null ? void 0 : s.btnSettingsSelectAll) ?? "Select all", o = ((c = this.params.content) == null ? void 0 : c.btnSettingsAccept) ?? "Accept selection";
  if (t.innerHTML !== "") {
    const a = document.createElement("div");
    a.className = "cc-window-settings-buttons", a.innerHTML = `
        ${i(this, W, Et).call(this, "cc-btn-settings-select", "cc-btn-settings-select", e)}
        ${i(this, W, Et).call(this, "cc-btn-settings-accept", "cc-btn-settings-accept", o)}
      `, t.appendChild(a);
  }
}, gt = new WeakSet(), we = function(t) {
  var e;
  if ((e = this.params.content) != null && e.settingsFooter) {
    const o = document.createElement("div");
    o.className = "cc-window-settings-footer", o.innerHTML = this.params.content.settingsFooter ?? "", t.appendChild(o);
  }
}, W = new WeakSet(), Et = function(t, e, o) {
  return `<button type="button" id="${t}" class="${e}">${o}</button>`;
}, pt = new WeakSet(), xe = function(t) {
  const e = document.getElementById(`cc-window-desc-id-${t}`), o = document.getElementById(`cc-window-icon-dropdown-id-${t}`);
  (e == null ? void 0 : e.style.display) === "block" && o ? (o.style.transform = "rotate(0deg)", e.style.display = "none") : e && o && (o.style.transform = "rotate(90deg)", e.style.display = "block");
}, P = new WeakSet(), St = function(t, e) {
  const o = document.createElement("div");
  o.id = t, o.className = "cc-modal";
  const s = document.createElement("div");
  s.className = "cc-modal-window";
  const c = document.createElement("div");
  if (c.className = "cc-modal-content", c.appendChild(e), !this.params.mainWindowSettings) {
    const d = document.createElement("div");
    d.id = "cc-modal-close", d.className = "cc-modal-close", d.innerHTML = "&times;", s.appendChild(d);
  }
  s.appendChild(c), o.appendChild(s), document.body.insertAdjacentElement("beforeend", o), o.style.display = "block";
  const a = document.getElementById("cc-modal-close");
  a == null || a.addEventListener("click", () => o.remove());
}, ht = new WeakSet(), Ce = function() {
  const t = document.getElementsByClassName("cc-modal");
  for (let e = 0; e < t.length; e++)
    t[e].remove();
}, z = new WeakSet(), $t = function() {
  const t = document.getElementById("cc-btn-accept"), e = document.getElementById("cc-btn-reject"), o = document.getElementById("cc-btn-info"), s = document.getElementById("cc-btn-settings"), c = document.getElementById("cc-btn-dismiss");
  t == null || t.addEventListener("click", () => {
    i(this, L, V).call(this), i(this, y, D).call(this), i(this, H, X).call(this, "accept_all"), i(this, O, Q).call(this, "accept"), i(this, C, S).call(this, "accept");
  }), e == null || e.addEventListener("click", () => {
    i(this, L, V).call(this), i(this, y, D).call(this), i(this, H, X).call(this, "reject_all"), i(this, O, Q).call(this, "reject"), i(this, C, S).call(this, "reject");
  }), o == null || o.addEventListener("click", () => {
    i(this, at, me).call(this);
  }), c == null || c.addEventListener("click", () => {
    i(this, j, K).call(this), i(this, G, vt).call(this);
  }), s == null || s.addEventListener("click", () => {
    i(this, R, Y).call(this);
  });
}, bt = new WeakSet(), ye = function() {
  const t = document.getElementById("cc-btn-settings-select"), e = document.getElementById("cc-btn-settings-accept");
  t && t.addEventListener("click", () => {
    i(this, kt, ve).call(this);
  }), e && e.addEventListener("click", () => {
    i(this, L, V).call(this), i(this, y, D).call(this), i(this, H, X).call(this, "selection"), i(this, O, Q).call(this, "selection"), i(this, ht, Ce).call(this), i(this, C, S).call(this, "accept");
  });
}, kt = new WeakSet(), ve = function() {
  const t = document.getElementById("cc-btn-settings-select"), e = t == null ? void 0 : t.dataset.action;
  if (t && (e === "select" || e === "unselect")) {
    const o = e === "select";
    t.innerHTML = o ? this.params.content.btnSettingsUnselectAll ?? "" : this.params.content.btnSettingsSelectAll ?? "", t.dataset.action = o ? "unselect" : "select", document.querySelectorAll(".cc-window-settings-cookie-value .cc-cookie-checkbox").forEach((c) => {
      c.disabled || (c.checked = o);
    });
  }
}, O = new WeakSet(), Q = function(t) {
  const e = this.params.expirationDays > 0 ? `expires=${new Date(Date.now() + this.params.expirationDays * 24 * 60 * 60 * 1e3).toUTCString()}` : "", o = btoa(`${t}:${Date.now()}`), s = {
    none: "SameSite=None;Secure",
    strict: "SameSite=Strict",
    lax: "SameSite=Lax"
  }, c = this.params.sameSite && s[this.params.sameSite] || s.lax, a = (u, p) => {
    document.cookie = `${u}=${p};${e};${this.params.path};${c};`;
  }, d = (u) => {
    document.cookie = `${u}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${this.params.path}; ${c};`;
  };
  a(l(this, U), o), Object.entries(l(this, m)).forEach(([u, p]) => {
    p.status ? a(u, btoa(`${u}:${Date.now()}`)) : d(u);
  }), xt(this, x, !0);
}, H = new WeakSet(), X = function(t) {
  if (l(this, m))
    if (t === "accept_all")
      for (const e in l(this, m))
        l(this, m)[e].status = !0;
    else if (t === "reject_all")
      for (const e in l(this, m))
        l(this, m)[e].status = !1;
    else
      t === "selection" && document.querySelectorAll(".cc-window-settings-cookie-value .cc-cookie-checkbox").forEach((o) => {
        const s = o.dataset.name;
        Object.entries(l(this, m)).forEach(([, c]) => {
          var a;
          s && (c == null ? void 0 : c.name) === s && (c.status = o.checked), s && ((a = c.parent) == null ? void 0 : a.name) === s && (c.status = o.checked);
        });
      });
}, C = new WeakSet(), S = function(t) {
  const e = (o) => {
    var c;
    const s = (c = this.params.callback) == null ? void 0 : c[o];
    if (s && typeof s == "function")
      try {
        s(l(this, m));
      } catch {
        console.error(`ERROR: Function ${o} not found`);
      }
  };
  switch (l(this, $).forEach((o) => {
    const s = i(this, A, q).call(this, o.name);
    if (s && s.manageFunction)
      try {
        s.manageFunction({ lifecycle: t, cookie: s, status: s.status, path: this.params.path });
      } catch {
        console.error(`ERROR: Function manageFunction not found in cookie ${s.name}`);
      }
  }), t) {
    case "first-load":
      e("first_load");
      break;
    case "load":
      e("load");
      break;
    case "accept":
      e("accept");
      break;
    case "reject":
      e("reject");
      break;
  }
};
function zn({
  lifecycle: n,
  cookie: t,
  status: e = !1,
  path: o = ""
}) {
  const s = t.code ?? "", c = t.onLoad ?? !1;
  if (s !== "")
    switch (n) {
      case "first-load":
        c ? (_t(s), M(s, !0)) : (M(s, !1), Ct(o));
        break;
      case "load":
      case "accept":
        e ? (_t(s), M(s, !0)) : (M(s, !1), Nt(), Ct(o));
        break;
      case "reject":
        M(s, !1), Nt(), Ct(o);
        break;
    }
  else
    console.error("ERROR: Google Analytics code not specified");
}
function _t(n) {
  if (n === "")
    return;
  const t = document.getElementById("cc-ga-script-1"), e = document.getElementById("cc-ga-script-2");
  if (t || Dt(`https://www.googletagmanager.com/gtag/js?id=${n}`, "cc-ga-script-1"), !e) {
    const o = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${n}', { 'anonymize_ip': true });
      gtag('config', '${n}');
      gtag('consent', 'default', { 'analytics_storage': 'denied' });
      window['ga-disable-' + '${n}'] = true;
    `;
    Dt(o, "cc-ga-script-2");
  }
}
function Dt(n, t) {
  const e = document.createElement("script");
  e.id = t, e[n.startsWith("http") ? "src" : "innerHTML"] = n, e.async = !0, document.head.appendChild(e);
}
function Nt() {
  var n, t;
  (n = document.getElementById("cc-ga-script-1")) == null || n.remove(), (t = document.getElementById("cc-ga-script-2")) == null || t.remove();
}
function M(n, t) {
  const e = document.getElementById("cc-ga-script-2");
  n !== "" && e && (gtag("set", "allow_google_signals", t), gtag("set", "allow_ad_personalization_signals", t), gtag("consent", "update", { analytics_storage: t ? "granted" : "denied" }), window[`ga-disable-${n}`] = !t);
}
function Ct(n) {
  const t = ["_ga", "_gid", "__utm"], o = document.cookie.split(";"), s = window.location.hostname.split(".");
  for (let c = 0; c < o.length; c++) {
    const a = o[c].split("=");
    for (let d = 0; d < t.length; d++)
      if (a.toString().trim().startsWith(t[d]) && (document.cookie = `${a[0]}="";domain=${window.location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`, s[0] === "www")) {
        const u = `.${s[1]}.${s[2]}`;
        document.cookie = `${a[0]}="";domain=${u};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`;
      }
  }
}
function Zn({
  lifecycle: n,
  cookie: t,
  status: e = !1,
  path: o = ""
}) {
  const s = t.code ?? "";
  if (s !== "")
    switch (n) {
      case "first-load":
      case "reject":
        Ut(), Ft(o);
        break;
      case "load":
      case "accept":
        e ? Fn(s) : (Ut(), Ft(o));
        break;
    }
  else
    console.error("ERROR: Google Tag Manager code not specified");
}
function Fn(n) {
  if (n === "")
    return;
  const t = document.getElementById("cc-gtm-script-1"), e = document.getElementById("cc-gtm-script-2");
  if (!t) {
    const o = Gn("cc-gtm-script-1", `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${n}');
    `);
    document.head.insertAdjacentElement("afterbegin", o);
  }
  if (!e) {
    const o = document.createElement("noscript");
    o.id = "cc-gtm-script-2", o.innerHTML = `
                <iframe src="https://www.googletagmanager.com/ns.html?id=${n}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`, document.body.insertAdjacentElement("afterbegin", o);
  }
}
function Ut() {
  Z("cc-gtm-script-1"), Z("cc-gtm-script-2"), Z('script[src^="https://www.googletagmanager.com/gtm.js"]'), Z('script[src^="https://www.google-analytics.com/analytics.js"]');
}
function Ft(n) {
  const t = ["_ga", "_gid", "__utm"], o = document.cookie.split(";"), s = window.location.hostname.split(".");
  for (let c = 0; c < o.length; c++) {
    const a = o[c].split("=");
    for (let d = 0; d < t.length; d++)
      if (a.toString().trim().startsWith(t[d]) && (document.cookie = `${a[0]}="";domain=${window.location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`, s[0] === "www")) {
        const u = `.${s[1]}.${s[2]}`;
        document.cookie = `${a[0]}="";domain=${u};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`;
      }
  }
}
function Gn(n, t) {
  const e = document.createElement("script");
  return e.id = n, e.innerHTML = t, e;
}
function Z(n) {
  const t = document.querySelector(`#${n}`) || document.querySelector(n);
  t && t.remove();
}
const Gt = "#2f3337", _ = "#ffffff", Jn = {
  window: {
    background: Gt
  },
  popup: {
    background: Gt,
    textColor: _
  },
  title: {
    textColor: _
  },
  message: {
    textColor: _,
    linkColor: _,
    linkFontWeight: "600"
  },
  settings: {
    separatorColor: "#ddd"
  },
  btnClose: {
    color: _,
    colorHover: "#ddd"
  },
  btnAccept: {
    background: "#388E3C",
    backgroundHover: "#1B5E20",
    textColor: "#ffffff",
    border: "0"
  },
  btnReject: {
    background: "#D32F2F",
    backgroundHover: "#B71C1C",
    textColor: "#ffffff",
    border: "0"
  },
  btnInfo: {
    background: "#EEE",
    backgroundHover: "#CCC",
    textColor: "#333",
    border: "0"
  },
  btnSettings: {
    background: "#EEE",
    backgroundHover: "#CCC",
    textColor: "#333",
    border: "0"
  },
  btnSettingsSelect: {
    background: "#EEE",
    backgroundHover: "#CCC",
    textColor: "#333",
    border: "0"
  },
  btnSettingsAccept: {
    background: "#388E3C",
    backgroundHover: "#1B5E20",
    textColor: "#ffffff",
    border: "0"
  }
}, g = "#ffffff", k = "#000000", qn = {
  window: {
    background: g
  },
  popup: {
    background: g,
    textColor: k
  },
  title: {
    textColor: k
  },
  message: {
    textColor: k,
    linkColor: k,
    linkFontWeight: "600"
  },
  settings: {
    separatorColor: "#000"
  },
  btnClose: {
    color: k,
    colorHover: "#666"
  },
  btnAccept: {
    background: g,
    backgroundHover: g,
    textColor: "#1B5E20",
    border: "0"
  },
  btnReject: {
    background: g,
    backgroundHover: g,
    textColor: "#B71C1C",
    border: "0"
  },
  btnInfo: {
    background: g,
    backgroundHover: g,
    textColor: k,
    border: "0"
  },
  btnSettings: {
    background: g,
    backgroundHover: g,
    textColor: k,
    border: "0"
  },
  btnSettingsSelect: {
    background: g,
    backgroundHover: g,
    textColor: k,
    border: "0"
  },
  btnSettingsAccept: {
    background: g,
    backgroundHover: g,
    textColor: k,
    border: "0"
  }
}, h = "#c2e7ff", w = "#001d35", Kn = {
  window: {
    background: h
  },
  popup: {
    background: h,
    textColor: w
  },
  title: {
    textColor: w
  },
  message: {
    textColor: w,
    linkColor: w,
    linkFontWeight: "600"
  },
  settings: {
    separatorColor: "#001d35"
  },
  btnClose: {
    color: w,
    colorHover: "#666"
  },
  btnAccept: {
    background: "#388E3C",
    backgroundHover: "#1B5E20",
    textColor: "#ffffff",
    border: "0"
  },
  btnReject: {
    background: "#D32F2F",
    backgroundHover: "#B71C1C",
    textColor: "#ffffff",
    border: "0"
  },
  btnInfo: {
    background: h,
    backgroundHover: h,
    textColor: w,
    border: "0"
  },
  btnSettings: {
    background: h,
    backgroundHover: h,
    textColor: w,
    border: "0"
  },
  btnSettingsSelect: {
    background: h,
    backgroundHover: h,
    textColor: w,
    border: "0"
  },
  btnSettingsAccept: {
    background: h,
    backgroundHover: h,
    textColor: w,
    border: "0"
  }
};
export {
  Pn as CookiesConsent,
  qn as contrastTheme,
  Jn as darkTheme,
  zn as manageGoogleAnalytics,
  Zn as manageGoogleTagManager,
  Kn as smoothTheme
};
